(function () {
	'use strict';
	angular.module('app.setup')
		.controller('projectSavingCategory', projectSavingCategory);

	projectSavingCategory.$inject = ['$scope', '$rootScope', '$timeout', '$uibModal', '$compile', 'storeService',
		'tableService', 'leanFilterService', 'projectSavingsCategoryService', 'tableRenderService'];
	function projectSavingCategory($scope, $rootScope, $timeout, $uibModal, $compile, storeService,
			tableService, leanFilterService, projectSavingsCategoryService, tableRenderService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var reportSettingsName = 'LeanProjectSavingCategories';
		var getSpecialControl;
		// Extra query params to send to backend in data requests
		var extraParams = [{
			'name': 'showArchive',
			'value': false
		}];
		var rendererParams = {};

		$scope.filterService = leanFilterService;
		$scope.processArchive = processArchive;

		vm.showExcel = false;
		vm.isAdmin = $rootScope.authz.isAdmin();
		vm.showAddProjectSavingCategory = vm.isAdmin;
		vm.addProjectSavingsCategory = addProjectSavingsCategory;
		vm.deleteProjectSavingsCategory = deleteProjectSavingsCategory;
		vm.updateProjectSavingsCategoryStatus = updateProjectSavingsCategoryStatus;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Savings & Spend Categories';

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				// If any data manipulation is needed, do it here
				return response;
			});
		}

		var columns = [
			{
				'id': 'name',
				'display': 'Category',
				'renderer': tableRenderService.projectSavingsCategoryRenderer,
				'deleteFunction': 'deleteProjectType',
				'requiredPermission': 'admin',
				'width': 400
			},
			{
				'id': 'savingType',
				'display': 'Type',
				'width': 100
			},
			{
				'id': 'includeInTotal',
				'display': 'Include in Totals',
				'renderer': tableRenderService.yesNo,
				'width': 100
			},
			{
				'id': 'noOfActiveLeanProjects',
				'display': '# of Active Lean Projects',
				'renderer': tableRenderService.integerWithLink,
				'urlGenerator': generateUrl,
				'ndxField': 'id',
				'disableLinkForEmptyOrZero': true,
				'width': 100
			},
			{
				'id': 'noOfActiveSupplierProjects',
				'display': '# of Active Supplier Projects',
				'renderer': tableRenderService.integerWithLink,
				'urlGenerator': generateUrl,
				'ndxField': 'id',
				'disableLinkForEmptyOrZero': true,
				'width': 100
			},
			{
				'id': 'noOfArchiveLeanProjects',
				'display': '# of Archive Lean Projects',
				'renderer': tableRenderService.integerWithLink,
				'ndxField': 'id',
				'width': 100,
				'disableLinkForEmptyOrZero': true,
				'urlGenerator': generateUrl
			},
			{
				'id': 'noOfArchiveSupplierProjects',
				'display': '# of Archive Supplier Projects',
				'renderer': tableRenderService.integerWithLink,
				'ndxField': 'id',
				'width': 100,
				'disableLinkForEmptyOrZero': true,
				'urlGenerator': generateUrl
			}
		];

		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: String.format('companyId/{0}/LeanProjects/SavingsCategory/Report', adminConfig.customer.id),
			noPaging: true,
			columns: columns,
			pinnedColumns: [],
			defaultSort: 'name',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: true,
			setColumnDefaults: true,
			noFactory: true,
			isGlobalReportSetting:true
		};

		var getSpecialControls = function () {
			var specialControl = document.getElementById('specialControls');

			if (specialControl) {
				clearInterval(getSpecialControl);
				addSpecialControl();
			}
		};

		function addSpecialControl() {
			$scope.showArchive = false;
			var template = '<div style=\"display: inline-block;bottom: 0px;vertical-align: bottom;line-height: 27px;position: absolute;\">' +
				'<span style=\"font-weight:bold;font-size:14px;\" translate>Show Archived</span> <input type=\"checkbox\" ng-change=\"processArchive()\" ng-model=\"showArchive\"></div>';
			var compiledDiv = $compile(template)($scope);

			jQuery('#specialControls').append(compiledDiv);
		}

		function processArchive() {
			var showArchiveIndex = _.findIndex(extraParams, ['name', 'showArchive']);
			if (showArchiveIndex !== -1) {
				extraParams[showArchiveIndex].value = $scope.showArchive;
			} else {
				extraParams.push({
					'name': 'showArchive',
					'value': $scope.showArchive
				});
			}
			$scope.$broadcast('reloadTable');
		}

		function init() {
			getSpecialControl = setInterval(getSpecialControls, 200);
			$scope.filterService.clearFilters();
			$scope.filterService.useAdminFactory = true;
		}

		function addProjectSavingsCategory(projectSavingCategory) {
			var projectSavingsCategoryFormScope = $scope.$new();
			projectSavingsCategoryFormScope.projectSavingCategory = jQuery.extend({}, projectSavingCategory);
			projectSavingsCategoryFormScope.action = (typeof projectSavingsCategoryFormScope.projectSavingCategory.id !== 'undefined' ? 'Edit' : 'Add');
			projectSavingsCategoryFormScope.customerNdx = adminConfig.customer.id;
			var opts = {
				scope: projectSavingsCategoryFormScope,
				templateUrl: '/application/f/setup/projects/savingCategories/project-saving-category-form.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			projectSavingsCategoryFormScope.closeDialog = function () {
				instance.close();
				projectSavingsCategoryFormScope.$destroy();
			};

			projectSavingsCategoryFormScope.result = function (message, isSuccessful) {
				$rootScope.$emit('toast', { 'message': message, 'success': isSuccessful });
				if (isSuccessful) {
					$scope.$broadcast('reloadTable');
				}
				instance.close();
				projectSavingsCategoryFormScope.$destroy();
			};
		}

		function deleteProjectSavingsCategory(row) {
			// User is not allowed to delete a category if there are savings for a category
			if (typeof row.categoryHasSavings !== 'undefined' && row.categoryHasSavings) {
				return;
			}

			var confirmScope = $scope.$new();
			confirmScope.projectSavingsCategoryId = row.id;
			confirmScope.additionalText = 'delete this project saving category';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				var projectSavingsCategoryId = confirmScope.projectSavingsCategoryId;
				instance.close();
				confirmScope.$destroy();
				deleteCustomerProjectSavingsCategory(projectSavingsCategoryId);
			};
		}

		function deleteCustomerProjectSavingsCategory(projectTypeIdToDelete) {
			projectSavingsCategoryService.deleteProjectSavingsCategory(projectTypeIdToDelete).then(function (response) {
				var success = false;
				var message = 'Failed to delete Savings Category';
				if (response === 'Savings Category deleted successfully') {
					success = true;
					message = response;
					$scope.$broadcast('reloadTable');
				}
				$rootScope.$emit('toast', {
					'message': message,
					'success': success
				});
			});
		}

		function generateUrl(type, ndx, factoryNdxs, row) {
			if (!row['noOfActiveLeanProjects'] && row['status'] === 'Archive') {
				return null;
			}
			var url = '/application/f/home.html#/lean-projects/view-projects/?drilldown=1&timePeriod=all&factory=LDNA_A_S';
			var stageIds = type.indexOf('Active') >= 0 ? row['activeStages'] : row['archiveStages'];
			if (type.indexOf('Supplier') >= 0) {
				url = '/application/f/home.html#/supply-chain/supplier-projects/?drilldown=1&timePeriod=all&factory=factory=LDNA_A_S';
			}
			url += '&projectSavingsCategoryId=' + ndx;
			url += '&projectStageId=' + stageIds;

			return url;
		}

		function updateProjectSavingsCategoryStatus(projectSavingsCategory) {
			var confirmScope = $scope.$new();
			var status = projectSavingsCategory.status == 'Active' ? 'Archive' : 'Active';
			confirmScope.statusConfirmText = projectSavingsCategory.status == 'Active' ? 'archive' : 'activate';
			confirmScope.prefixText = status === 'Archive' ? 'Archiving this category will remove it from the list of available savings and spend types in projects that do not currently have values assigned to it. ': '';
			confirmScope.additionalText = confirmScope.statusConfirmText + ' this Savings Category';
			confirmScope.buttonText = projectSavingsCategory.status == 'Active' ? 'Archive' : 'Activate';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				instance.close();
				confirmScope.$destroy();
				var projectSavingsCategoryObj = {};
				projectSavingsCategoryObj.id = projectSavingsCategory.id;
				projectSavingsCategoryObj.status = status;
				projectSavingsCategoryObj.customerNdx = adminConfig.customer.id;
				var lastModified = (typeof projectSavingsCategory.lastModified === 'undefined') ? (new Date()).toUTCString() : (new Date(projectSavingsCategory.lastModified)).toUTCString();

				projectSavingsCategoryService.updateProjectSavingsCategory(projectSavingsCategoryObj, lastModified, adminConfig.customer.id).then(function (message) {
					var toastMessage = '';
					var isSuccessful = false;
					if (_.isString(message)) {
						toastMessage = message;
					} else {
						isSuccessful = message.data.id === projectSavingsCategoryObj.id;
						toastMessage = 'Savings Category ' + confirmScope.statusConfirmText + 'd successfully';
						if (isSuccessful) {
							$scope.$broadcast('reloadTable');
						}
					}
					$rootScope.$emit('toast', {
						'message': toastMessage,
						'success': isSuccessful
					});
				});
			};
		}

		init();
	}
})();
